const getCurrentStudent = state => state.currentStudent;

const getCurrentStudentName = state => state.currentStudentName;

export default {
  getCurrentStudent,
  getCurrentStudentName
};



// WEBPACK FOOTER //
// ./src/store/modules/students/getters.js